if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewed extends customElements.get('card-product-slider') {
    constructor() {
      super();
      this.section = this.closest('.js-section');
      this.sliderWrapper = this.querySelector('.swiper-wrapper');
      this.productHandle = this.dataset.productHandle;
    }

    connectedCallback() {
      if (this.recentStarted || this.recentObserver || !this.getRecentHandles().length) return;
      if ('IntersectionObserver' in window) {
        this.recentObserver = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.recentObserver.disconnect();
          this.recentObserver = null;
          this.fetchRecentProducts();
        }, { rootMargin: '600px 0px' });
        this.recentObserver.observe(this.closest('.shopify-section') || this);
        return;
      }
      this.fetchRecentProducts();
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.recentObserver?.disconnect();
      this.recentObserver = null;
    }

    getRecentHandles() {
      try {
        const limit = Math.max(1, Math.min(12, Number(this.dataset.productsLimit) || 8));
        return [...new Set((localStorage.getItem('recently-viewed') || '').split(','))]
          .filter(handle => handle && handle !== this.productHandle)
          .slice(0, limit);
      } catch {
        return [];
      }
    }

    async fetchRecentProducts() {
      if (this.recentStarted) return;
      this.recentStarted = true;
      const handles = this.getRecentHandles();
      const slides = await Promise.all(handles.map(async handle => {
        try {
          const response = await fetch(
            `${window.Shopify.routes.root}products/${encodeURIComponent(handle)}?view=card`
          );
          if (!response.ok) {
            if (response.status === 404 || response.status === 410) {
              try {
                const history = (localStorage.getItem('recently-viewed') || '').split(',');
                localStorage.setItem('recently-viewed', history.filter(item => item !== handle).join(','));
              } catch {}
            }
            return null;
          }
          const slide = document.createElement('div');
          slide.classList.add('swiper-slide', 'card-product-slider__slide');
          slide.innerHTML = await response.text();
          return slide.querySelector('card-product') && slide.querySelector('.card-product') ? slide : null;
        } catch {
          return null;
        }
      }));
      const validSlides = slides.filter(Boolean);
      if (!validSlides.length) return;
      this.sliderWrapper.append(...validSlides);
      this.section?.classList.remove('hidden');
      this.initSlider();
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewed);
}
